import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import PermissionsService from '@services/permissions';
import PermissionTemplatesService from '@services/permission-templates';
import * as actions from '@actions';
import { Permission, PermissionTemplate, PermissionTemplateCode } from '@rootCommon/types/permission';

import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// fetch
function* fetchPermissionsAsync(action: { payload: PermissionTemplateCode }) {
  try {
    const permissions: Permission[] = yield call(PermissionsService.getListByCode, action.payload);

    yield put(actions.fetchPermissions.success(permissions));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchPermissions.failure(error));
  }
}

function* watchFetchPermissions() {
  yield takeLatest(actions.fetchPermissions.request, fetchPermissionsAsync);
}

// fetch
function* fetchPermissionTemplatesAsync() {
  try {
    const permissionTemplates: PermissionTemplate[] = yield call(PermissionTemplatesService.getList);

    yield put(actions.fetchPermissionTemplates.success(permissionTemplates));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchPermissionTemplates.failure(error));
  }
}

function* watchFetchPermissionTemplates() {
  yield takeLatest(actions.fetchPermissionTemplates.request, fetchPermissionTemplatesAsync);
}

// all
function* watchPermissions(): SagaGenerator {
  yield all([watchFetchPermissions(), watchFetchPermissionTemplates()]);
}

export default watchPermissions;
